import { gql } from '@apollo/client';

export const GET_USER_FLOW_STEP_QUERY = gql`
  query getUserFlowStep($userFlowStepId: Int!) {
    userFlowStep {
      getUserFlowStep(userFlowStepId: $userFlowStepId) {
        contentGroup {
          contentPages(status: [PUBLISHED]) {
            parentId
            sort
            url
          }
          lastViewedContentPage {
            url
          }
          title
        }
        id
        stepName
        url
      }
    }
  }
`;
